import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe as NgxTranslatePipe, TranslateService } from '@ngx-translate/core';
import { hasValue, isArray, toObjectByIndex } from '@util';
import { head } from 'ramda';

@Pipe({
  name: 'translate',
  pure: false
})
export class TranslatePipe extends NgxTranslatePipe implements PipeTransform {
  constructor(private translateService: TranslateService, private cdr: ChangeDetectorRef) {
    super(translateService, cdr);
  }

  transform(value: any, ...args: any[]): any {
    if (!hasValue(args)) {
      return super.transform(value, args);
    }
    const params = head(args);
    if (isArray(params)) {
      return super.transform(value, toObjectByIndex(params));
    }

    return super.transform(value, params);
  }

}
